import { Env } from "../../env";
import { CarouselItem } from "../item";
import { isSoloare } from "../js_env";
import { ModalRecommendJsEnv } from "./modal_recommend_js_env";

export class AddCartModalState {
  constructor(private model: ModalRecommendJsEnv) {
    this.model = { ...model };

    if (isSoloare(Env.SITE_TYPE)) {
      this.model.rrAreaProfileItemModal = {
        placementName: "tr_modal_recommend",
        displayCount: 30,
        rrAreaItems: [],
        rrAreaTitle: "",
        perView: 4
      };
    }
  }

  getModel(): ModalRecommendJsEnv {
    return {
      ...this.model
    };
  }

  setModalRecommendAreaItemModel(carouselItemList: CarouselItem[], recommendAreaTitle: string): void {
    this.model.rrAreaProfileItemModal.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileItemModal.rrAreaTitle = recommendAreaTitle;
  }
}